import { AuthFeature } from '../apis/generated';
import { useAccess } from '../contexts/remote-data/useAccess';

export function useIsSiteEditor(): boolean | undefined {
  const { access } = useAccess();

  return access?.available_features?.includes(AuthFeature.SITE_EDITOR);
}
